(function($) {

    if ($('html').is(':lang(fr)')) {
        setTimeout( function() {
            $('.menu-item-766').text('Gérer les paramètres des cookies');
            $('.menu-item-766').prop('title', 'Gérer les paramètres des cookies');
        }, 1300 );
    }


})(jQuery);
